// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cz2.cz2 .cz2__switch-pop-wrapper{display:flex;justify-content:center;gap:16px}#cz2.cz2 .cz2__switch-pop-snapshot{margin-bottom:16px;flex:1 1 auto;aspect-ratio:675/900;background-size:contain;background-repeat:no-repeat}#cz2.cz2 .cz2__switch-pop-arrow{align-self:center}#cz2.cz2 .cz2__switch-pop-arrow.flip{transform:scaleX(-1)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
